import Loadable from 'react-loadable';
import ComponentLoading from 'components/ComponentLoading/ComponentLoading';
var LoadableOrgUserDetail = Loadable({
  loader: function loader() {
    return import('../OrgUserDetail.jsx');
  },
  loading: ComponentLoading
});
export default LoadableOrgUserDetail;